import React from 'react';

import "./HeadPane.scss";
//import { Menu, MenuLink } from '../../elements/Menu/Menu';
import { Link } from "@randajan/jet-react/dom/link";
import { Menu } from "@randajan/jet-react/dom/menu";
import { Img } from "@randajan/jet-react/dom/img";

import { Router } from '../../pages/Router';
import { screen, page } from '../../config/base';
import lang from '../../config/lang';

export const MenuLink = props=><Link {...props} onClick={Menu.use().blur}/>

export const HeadPane = () => {
    const [ screen960w ] = screen.use("960w");
    const isFlat = screen960w.get();
    
    return (
        <nav className="HeadPane wall">
            <div className="block">
                <Link className="logo" to="/"><Img src="/imgs/logo/logoItcan_plainColor.svg"/></Link>
                <Menu position="top" trigger={<Img src="/icons/threeDots.svg"/>} flat={ isFlat } transition={600}>
                    {Router.mapRoutes(({ path, menuLabel }, key)=>{
                        if (!menuLabel) { return null; }
                        return <MenuLink key={key} to={path}>{menuLabel}</MenuLink>
                    })}
                    <MenuLink to="#contact=up">kontakt</MenuLink>
                </Menu>
            </div>
        </nav>
    )
}

export default HeadPane;
